import { Component, OnInit, ViewChild, AfterViewInit, EventEmitter, Output, OnDestroy } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../main/main.component';
import { NumberUtils } from 'src/app/utils/number-utils';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';

import { SsoService } from 'src/app/services/sso/sso.service';
import { FlotaService } from '../../services/flota/flota.service';
import { ResourcesService } from 'src/app/services/resources/resources.service';

import { MovilModel } from 'src/app/services/resources/models/movil.model';
import { SubflotaModel } from 'src/app/services/flota/models/subflota.model';

@Component({
  selector: 'app-moviles-select',
  templateUrl: './moviles-select.component.html',
  styleUrls: ['./moviles-select.component.css']
})
export class MovilesSelectComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('grid') grid: jqxGridComponent;
  @ViewChild('selectSubflotas') selectSubflotas: jqxDropDownListComponent;

  @Output() passArray = new EventEmitter
  private select: MovilModel[] = [];

  public environment = environment;

  // Para la cabecera del grid
  private static toolbarContainer = null;
  private static searchControl = null;

  // Variables para generar el listado
  private moviles: MovilModel[] = []
  public subflotas: SubflotaModel[] = [];
  public movilesSubf: MovilModel[] = [];
  public dataSource;
  public dataAdapter;

  // Preparo las columnas del grid
  public columns = [

    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', hidden: true },
    { text: '', columntype: 'image', datafield: 'imagen', width: 25, cellsrenderer: this.imagerenderer },
    {
      text: AppComponent.translate('Descripcion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 'auto',
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            NumberUtils.format(aggregates["Total"], 0) + '</div>';
        }
        return renderstring;
      }
    },
    { text: 'Selec', columntype: 'textbox', filtertype: 'textbox', datafield: 'selec', hidden: true, width: 1 }
  ];

  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');

  constructor(
    private ssoService: SsoService,
    private resourcesService: ResourcesService,
    private flotaService: FlotaService
  ) { }

  ngOnInit(): void {
    // Cargo el idioma para los componentes jqwidgets
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
    this.getMoviles();
  }

  ngAfterViewInit(): void {
    this.initGridHeader();
    this.getSubflotas();
  }

  ngOnDestroy(): void {
    if (MovilesSelectComponent.toolbarContainer) {
      MovilesSelectComponent.toolbarContainer.remove();
    }
  }


  expanded(event) {

    console.log(event)


  }

  Collapsed(event) {

    console.log(event)
  }



  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  // Obtiene los moviles
  private async getMoviles() {
    this.moviles = await this.resourcesService.getMoviles();
    if (this.moviles) {
      this.dataSource = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Codigo' },
          { name: 'imagen', type: 'image', map: 'ConjuntoVehiculo>Icono' },
          { name: 'nombre', type: 'string', map: 'Nombre' },
          { name: 'selec', map: 'selec', type: 'string' }
        ],
        localdata: this.moviles,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      };
      this.dataAdapter = new jqx.dataAdapter(this.dataSource);
    } else {
      this.moviles = [];
    }
  }

  imagerenderer(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    return value ? '<img style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="data:image/jpg;base64,' + value + '"/>' :
      '<img style="margin-left: 4px; margin-top: 2px;" height="16" width="16" src="assets/images/car.png" />';
  }

  // Cada select/unselect recorre las columnas y seleccionados y los añade a un array
  onSelect() {
    /* this.select = [];
    const rows = this.grid.getrows();
    const selec = this.grid.getselectedrowindexes();
    if (rows) {
      rows.forEach(row => {
        for (let i = 0; i < selec.length; i++) {
          if (row.boundindex === selec[i]) {
            let item = this.moviles.find(movil => movil.Codigo === row.id);
            if (item) {
              this.select.push(item);
            }
          }
        }
      });
    } */

    this.select = [];
    const selec = this.grid.getselectedrowindexes();
    if(selec){
      selec.forEach(element => {
        this.select.push(this.moviles[element]);
      });
    }
    this.passArray.emit(this.select);
  }

  getSelection(): MovilModel[] {
    return this.select;
  }

  // Crea los componentes de la cabecera
  createToolBar(statusbar: any) {
    if (statusbar[0] !== undefined) {
      // Añado el control de búsqueda a la cabecera
      MovilesSelectComponent.toolbarContainer = document.createElement('div');
      MovilesSelectComponent.toolbarContainer.style.cssText = 'overflow: hidden; position: relative; margin-left: 3px; margin-top: 0px';
      MovilesSelectComponent.toolbarContainer.id = 'movilesSelec' + Math.random().toString(16).substring(2);
      MovilesSelectComponent.searchControl = document.createElement('div');
      MovilesSelectComponent.searchControl.id = 'searchControl' + Math.random().toString(16).substring(2);
      MovilesSelectComponent.searchControl.style.cssText = `
          float: left;
          background-color: white;
          background-image: url('../assets/images/search.png');
          background-repeat: no-repeat;
          background-position: 4px center;
          background-size: 18px;
          display: flex;
          align-items: center;
          width: 99%;
          margin-top: 3px;
          padding-top: 2px;
          padding-left: 28px;
          height: 24px;
          border: 1px solid rgba(0, 0, 0, 0.5);
          border-radius: 3px;
          overflow: hidden;
        `;
      MovilesSelectComponent.searchControl.innerHTML = '<input type="text" style="border: 0;width: 100%; outline: none;" (keydown.enter)="$event.preventDefault()" ' +
        'placeholder="' + MainComponent.getInstance().translate('Buscar') + '..." autocorrect = "off" autocapitalize = "off" spellcheck = "off">';
      MovilesSelectComponent.toolbarContainer.appendChild(MovilesSelectComponent.searchControl);
      statusbar[0].appendChild(MovilesSelectComponent.toolbarContainer);
    }
  }

  // Inicializa los controles de la cabecera del grid
  initGridHeader(): void {
    if (MovilesSelectComponent.searchControl) {
      MovilesSelectComponent.searchControl.addEventListener('input', (event: any) => {
        const searchText = event.target.value.toUpperCase();
        this.moviles.forEach(movil => {
          if ((movil['Nombre'] && movil['Nombre'].toUpperCase().indexOf(searchText) > -1)) {
            movil['selec'] = 'selec';
          } else {
            movil['selec'] = '';
          }
        });
        // Compruebo si ya he creado el filtro "selec" anteriormente
        const filters = this.grid.getfilterinformation();
        if (filters.find(s => s.datafield === 'selec') === undefined) {
          const filtergroup = new jqx.filter();
          filtergroup.addfilter(1, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
          this.grid.addfilter('selec', filtergroup);
        }
        this.grid.applyfilters();
        this.grid.updatebounddata('data');
      });
    }
  }

  // Rellena la lista de subflotas
  async getSubflotas() {
    const item = {
      id: 'todo',
      html: '<div style="height: 20px; float: left;">' +
        '<span style="float: left; font-size: 13px;">' + AppComponent.translate('Todas') + '</span></div>'
    };
    const item2 = {
      id: 0,
      html: '<div style="height: 20px; float: left;">' +
        '<span style="float: left; font-size: 13px;">' + AppComponent.translate('Resto_flota') + '</span></div>'
    };
    this.selectSubflotas.addItem(item);
    this.selectSubflotas.selectIndex(0);
    this.subflotas = await this.flotaService.getSubflotas();
    if (this.subflotas) {
      this.subflotas.forEach(subflota => {
        const item = {
          id: subflota.Id,
          html: '<div style="height: 20px; float: left;">' +
            '<span style="float: left; font-size: 13px;">' + subflota.Nombre + '</span></div>'
        };
        this.selectSubflotas.addItem(item);
      });
    }
    this.selectSubflotas.addItem(item2);

    const t = setTimeout(() => {
      clearTimeout(t);
      this.grid.autoresizecolumns();
    }, 500);
  }

  // Obtiene listado de subflotas
  async onChangeSubflotas(event: any) {
    let subflotaId = event.args.item.value['id'];
    this.grid.clearselection();
    let subAdapter = new jqx.dataAdapter(this.dataSource, {
      beforeLoadComplete: (records: any[]): void => { //Si el movil no coincide con el Id de la flota, se quita del array
        for (let i = 0; i < records.length; i++) {
          this.moviles.forEach(movil => {
            if (records[i]) {
              if (movil.Subflota.Id !== subflotaId && records[i]['id'] == movil['Codigo']) {
                records.splice(i, 1)
                i--
              }
            }
          })
        }
        records.sort((a, b) => (a.Nombre < b.Nombre) ? -1 : 1)
      }
    });
    // Si marca todas, no aplica ningún filtro
    if (subflotaId === 'todo') {
      subAdapter = new jqx.dataAdapter(this.dataSource)
    }
    this.grid.setOptions({ source: subAdapter });
  }

}
